import { useNavigate, useParams } from 'react-router-dom';
import { Button, message, Popconfirm } from 'antd';

import { useDeleteRequest } from 'hooks';

import { Links } from 'links';

export const DeleteProduct = () => {
  const { productId } = useParams();
  const navigate = useNavigate();

  const [deleteProduct, { loading }] = useDeleteRequest({
    url: `products/details/${productId}`,
    options: {
      onSuccess: () => {
        message.success('Product deleted successfully!');
        navigate(Links.Products);
      },
    },
  });

  return (
    <Popconfirm
      title='You sure? This action cannot be reverted!'
      onConfirm={() => deleteProduct()}
    >
      <Button
        danger
        size='small'
        type='primary'
        loading={loading}
      >
        Delete
      </Button>
    </Popconfirm>

  );
};
